/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: tduzggWPyptPHtemkm2DXC
// Component: VxkXyrb2gqH-

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { LGTimeFromNow } from "@lg-plus/landing-components"; // plasmic-import: xeQbhUPw4cop/codeComponent
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: tduzggWPyptPHtemkm2DXC/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: tduzggWPyptPHtemkm2DXC/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicMoneyToAccountTime.module.css"; // plasmic-import: VxkXyrb2gqH-/css

createPlasmicElementProxy;

export type PlasmicMoneyToAccountTime__VariantMembers = {};
export type PlasmicMoneyToAccountTime__VariantsArgs = {};
type VariantPropType = keyof PlasmicMoneyToAccountTime__VariantsArgs;
export const PlasmicMoneyToAccountTime__VariantProps =
  new Array<VariantPropType>();

export type PlasmicMoneyToAccountTime__ArgsType = {};
type ArgPropType = keyof PlasmicMoneyToAccountTime__ArgsType;
export const PlasmicMoneyToAccountTime__ArgProps = new Array<ArgPropType>();

export type PlasmicMoneyToAccountTime__OverridesType = {
  root?: Flex__<"div">;
  freeBox?: Flex__<"div">;
  text?: Flex__<"div">;
  lgTimeFromNow?: Flex__<typeof LGTimeFromNow>;
};

export interface DefaultMoneyToAccountTimeProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicMoneyToAccountTime__RenderFunc(props: {
  variants: PlasmicMoneyToAccountTime__VariantsArgs;
  args: PlasmicMoneyToAccountTime__ArgsType;
  overrides: PlasmicMoneyToAccountTime__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_tduzggWPyptPHtemkm2DXC",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      <PlasmicImg__
        alt={""}
        className={classNames(sty.img__yeCaS, {
          [sty.imgglobal_themeOrange_override__yeCaSdYuRs]: hasVariant(
            globalVariants,
            "themeOrange",
            "override"
          )
        })}
        displayHeight={
          hasVariant(globalVariants, "themeOrange", "override")
            ? "25px"
            : "auto"
        }
        displayMaxHeight={"none"}
        displayMaxWidth={"100%"}
        displayMinHeight={"0"}
        displayMinWidth={"0"}
        displayWidth={
          hasVariant(globalVariants, "themeOrange", "override")
            ? "25px"
            : "auto"
        }
        loading={"lazy"}
        src={
          hasVariant(globalVariants, "themeOrange", "override")
            ? {
                src: "/plasmic/nebank/images/iconFastOrangeSvg.svg",
                fullWidth: 24,
                fullHeight: 25,
                aspectRatio: undefined
              }
            : {
                src: "/plasmic/nebank/images/iconFastSvg.svg",
                fullWidth: 40,
                fullHeight: 20,
                aspectRatio: undefined
              }
        }
      />

      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames("all", sty.freeBox)}
      >
        <div
          data-plasmic-name={"text"}
          data-plasmic-override={overrides.text}
          className={classNames("all", "__wab_text", sty.text, {
            [sty.textglobal_themeOrange_override]: hasVariant(
              globalVariants,
              "themeOrange",
              "override"
            ),
            [sty.textglobal_themePurpleDark_override]: hasVariant(
              globalVariants,
              "themePurpleDark",
              "override"
            )
          })}
        >
          <React.Fragment>
            {(() => {
              try {
                return `Peníze na účtu do `;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return "Peni\u0301ze na u\u0301c\u030ctu do 23:45";
                }
                throw e;
              }
            })()}
          </React.Fragment>
        </div>
        <LGTimeFromNow
          data-plasmic-name={"lgTimeFromNow"}
          data-plasmic-override={overrides.lgTimeFromNow}
          className={classNames("__wab_instance", sty.lgTimeFromNow, {
            [sty.lgTimeFromNowglobal_themePurpleDark_override]: hasVariant(
              globalVariants,
              "themePurpleDark",
              "override"
            )
          })}
          offsetMinutes={15}
          placeholder={"--:--"}
          template={"{time}"}
        />
      </div>
      <PlasmicImg__
        alt={""}
        className={classNames(sty.img__nQiX2, {
          [sty.imgglobal_themeOrange_override__nQiX2DYuRs]: hasVariant(
            globalVariants,
            "themeOrange",
            "override"
          )
        })}
        displayHeight={"auto"}
        displayMaxHeight={"none"}
        displayMaxWidth={"100%"}
        displayMinHeight={"0"}
        displayMinWidth={"0"}
        displayWidth={"auto"}
        loading={"lazy"}
        src={
          hasVariant(globalVariants, "themeOrange", "override")
            ? {
                src: "/plasmic/nebank/images/iconWarningOrangeSvg.svg",
                fullWidth: 26,
                fullHeight: 25,
                aspectRatio: undefined
              }
            : {
                src: "/plasmic/nebank/images/iconWarningSvg.svg",
                fullWidth: 22,
                fullHeight: 20,
                aspectRatio: undefined
              }
        }
      />
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "freeBox", "text", "lgTimeFromNow"],
  freeBox: ["freeBox", "text", "lgTimeFromNow"],
  text: ["text"],
  lgTimeFromNow: ["lgTimeFromNow"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  freeBox: "div";
  text: "div";
  lgTimeFromNow: typeof LGTimeFromNow;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicMoneyToAccountTime__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicMoneyToAccountTime__VariantsArgs;
    args?: PlasmicMoneyToAccountTime__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicMoneyToAccountTime__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicMoneyToAccountTime__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicMoneyToAccountTime__ArgProps,
          internalVariantPropNames: PlasmicMoneyToAccountTime__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicMoneyToAccountTime__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicMoneyToAccountTime";
  } else {
    func.displayName = `PlasmicMoneyToAccountTime.${nodeName}`;
  }
  return func;
}

export const PlasmicMoneyToAccountTime = Object.assign(
  // Top-level PlasmicMoneyToAccountTime renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),
    text: makeNodeComponent("text"),
    lgTimeFromNow: makeNodeComponent("lgTimeFromNow"),

    // Metadata about props expected for PlasmicMoneyToAccountTime
    internalVariantProps: PlasmicMoneyToAccountTime__VariantProps,
    internalArgProps: PlasmicMoneyToAccountTime__ArgProps
  }
);

export default PlasmicMoneyToAccountTime;
/* prettier-ignore-end */
